var exports = {
  "x6": "HelpButton.module__button___V3lQY0",
  "td": "HelpButton.module__iconText___V3lQY0",
  "ro": "HelpButton.module__menuIcon___V3lQY0",
};

module.exports = exports;
